import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeleteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"delete"}/>
}
